export interface Pillar {
  emoji: string
  title: string
  description: string
}

export const pillars: Pillar[] = [
  {
    emoji: '🤰',
    title: 'Assess Your Client',
    description: 'Start with organized information instead of assumptions.',
  },
  {
    emoji: '🏋️',
    title: 'Build Better Sessions',
    description:
      'Use structured exercises, sessions and modification options instead of searching from scratch.',
  },
  {
    emoji: '📋',
    title: 'Plan With Structure',
    description: 'Turn individual workouts into coherent multi-week programs.',
  },
  {
    emoji: '⏱️',
    title: 'Save Planning Time',
    description:
      'Use ready-to-use professional resources instead of rebuilding everything every week.',
  },
]
